import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { DialogComponent } from './dialog/dialog.component';
import { TranslationIdMap } from './dialog/dialog.component.i18n';

@NgModule({
    declarations: [DialogComponent],
    exports: [DialogComponent],
    imports: [
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
        CmpsButtonModule,
        CmpsTooltipModule,
    ],
})
export class CmpsQuickAccessModule {}
